"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _link = _interopRequireDefault(require("./link"));
var _content = _interopRequireDefault(require("./content"));
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Creates a `menuItem` content model
 *
 * @param {object} entry
 * @param {object} entry.sys
 * @param {string} entry.sys.id
 * @param {object} entry.fields
 * @param {string} entry.fields.name - The display name for the menu item
 * @param {object} entry.fields.link - A Contentful Entry representing the link
 * @param {array<object>} [entry.fields.items] - An array of sub-menus, [optional]
 * @returns `menuItem` content model
 */
var createMenuItem = function createMenuItem(_ref) {
  var _fields$items;
  var sys = _ref.sys,
    fields = _ref.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    link: (0, _link["default"])({
      fields: fields
    }),
    items: (fields === null || fields === void 0 ? void 0 : (_fields$items = fields.items) === null || _fields$items === void 0 ? void 0 : _fields$items.length) > 0 ? (0, _utils.filterItemsBySite)(fields.items).map(function (item) {
      return createMenuItem(item);
    }) : null
  };
};

/**
 * Creates a `menu` content model
 *
 * @param {object} entry
 * @param {object} entry.sys
 * @param {string} entry.sys.id
 * @param {object} entry.fields
 * @param {array<object>} [entry.fields.items] - All the `menuItem` entries for the menu, [optional]
 * @returns `menu` content model
 */
var menuFactory = function menuFactory(_ref2) {
  var _fields$items2;
  var sys = _ref2.sys,
    fields = _ref2.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    preMenuItems: fields !== null && fields !== void 0 && fields.preMenuItems ? (0, _utils.filterItemsBySite)(fields.preMenuItems).map(_content["default"]) : [],
    items: (fields === null || fields === void 0 ? void 0 : (_fields$items2 = fields.items) === null || _fields$items2 === void 0 ? void 0 : _fields$items2.length) > 0 ? (0, _utils.filterItemsBySite)(fields.items).map(function (item) {
      return createMenuItem(item);
    }) : null,
    postMenuItems: fields !== null && fields !== void 0 && fields.postMenuItems ? (0, _utils.filterItemsBySite)(fields.postMenuItems).map(_content["default"]) : []
  };
};
var _default = menuFactory;
exports["default"] = _default;